<template>
  <div class="mt-6 md:mt-12">
    <button @click="scrollTo(buttonHref)"
      class="flex items-center px-12 py-3 mx-auto text-base rounded-full md:text-xl md:px-24 lg:py-4 font-ww-medium btn-red gap-x-2">{{ buttonText }}</button>
  </div>
</template>

<script setup>
const props = defineProps({
  buttonHref: {
    type: String,
    default: 'products',
  },
  buttonText: {
    type: String,
    default: 'Get Discount',
  }
});

defineBuilderComponent({
  friendlyName: 'CTA Button',
  inputs: [
    {
      name: 'buttonHref',
      type: 'text',
      friendlyName: 'Button Link',
      defaultValue: 'products',
    },
    {
      name: 'buttonText',
      type: 'text',
      friendlyName: 'Button Text',
      defaultValue: 'Get Discount',
    }
  ],
});
</script>